// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.callback_header{
    display: flex;
    margin: 5%;
    flex-wrap: nowrap;
    justify-content: space-between;
}
.callback_header img{
    width: 164px;
    height: auto;
}
.callback_header i{
    font-size: 30px;
    color: var(--couleur-secondaire);
}
.callback_content{
    text-align: center;
    margin: 5%;
    margin-top: 20%;
}
.callback_content h1{
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 10px;
    color: var(--vert-principale);
}
.callback_content i{
    font-size: 50px;
    color: var(--vert-principale);
    margin-bottom: 10px;
}
.callback_content span{
    font-size: 24px;
    color: var(--couleur-secondaire);
    margin-top: 1%;
    text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/callback/callback.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,UAAU;IACV,iBAAiB;IACjB,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,YAAY;AAChB;AACA;IACI,eAAe;IACf,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gCAAgC;IAChC,cAAc;IACd,0BAA0B;AAC9B","sourcesContent":[".callback_header{\n    display: flex;\n    margin: 5%;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n}\n.callback_header img{\n    width: 164px;\n    height: auto;\n}\n.callback_header i{\n    font-size: 30px;\n    color: var(--couleur-secondaire);\n}\n.callback_content{\n    text-align: center;\n    margin: 5%;\n    margin-top: 20%;\n}\n.callback_content h1{\n    font-size: 32px;\n    font-weight: 700;\n    margin-bottom: 10px;\n    color: var(--vert-principale);\n}\n.callback_content i{\n    font-size: 50px;\n    color: var(--vert-principale);\n    margin-bottom: 10px;\n}\n.callback_content span{\n    font-size: 24px;\n    color: var(--couleur-secondaire);\n    margin-top: 1%;\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
